import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/vehiculos/vehiculos';
import VehiculosList from './Vehiculos';


const ms2p = (state) => {
  return {
    ...state.vehiculos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(VehiculosList);
